(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rx-base"] && !Shopify.designMode) return;
  try {
    (function(){
    document.addEventListener('click', function(e){
      var b = e.target.closest('[data-rx-add]');
      if (!b) return;
      var ids = (b.getAttribute('data-rx-add') || '').split(',').filter(Boolean);
      if (!ids.length) return;
      e.preventDefault();
      var label = b.textContent;
      b.disabled = true;
      b.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map(function(id){ return { id: Number(id), quantity: 1 }; }) })
      }).then(function(r){
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function(){
        window.location.href = '/cart';
      }).catch(function(){
        b.disabled = false;
        b.textContent = label;
        alert('Sorry, we could not add that to your cart. Please try again.');
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rx-media"] && !Shopify.designMode) return;
  try {
    (function(){
    function init(){
      var c = {};
      try { c = navigator.connection || {}; } catch (e) {}
      var slow = !!(c.saveData || /^(slow-2g|2g|3g)$/.test(c.effectiveType || ''));
      var small = !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
      var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

      /* Phones get the lighter 480p file (the hero keeps 720p on a fast connection). */
      [].slice.call(document.querySelectorAll('video[data-rx-sm]')).forEach(function(v){
        var keepHq = v.hasAttribute('data-rx-hq') && !slow && (!c.effectiveType || c.effectiveType === '4g');
        if (!small || keepHq) return;
        var sm = v.getAttribute('data-rx-sm');
        if (!sm) return;
        v.addEventListener('error', function(){
          if (v.getAttribute('src') !== sm) return;
          v.removeAttribute('src'); v.load();
          if (v.getAttribute('data-rx-in') === '1') { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
        });
        v.src = sm; v.load();
      });

      /* Clips that start part-way in (data-rx-loopfrom): begin there and loop back to that point, never to 0:00. */
      [].slice.call(document.querySelectorAll('video[data-rx-loopfrom]')).forEach(function(v){
        var lf = parseFloat(v.getAttribute('data-rx-loopfrom')) || 0;
        if (!(lf > 0)) return;
        function back(){ try { v.currentTime = lf; } catch (e) {} }
        v.addEventListener('loadedmetadata', function(){ if (v.duration > lf + 1 && v.currentTime < lf - 0.3) back(); });
        v.addEventListener('timeupdate', function(){ if (v.duration > 1 && v.currentTime >= v.duration - 0.15) back(); });
        v.addEventListener('ended', function(){ back(); var p = v.play(); if (p && p.catch) p.catch(function(){}); });
      });

      var vids = [].slice.call(document.querySelectorAll('video[data-rx-inview]'));
      if (!vids.length) return;
      if (slow || reduce) {
        vids.forEach(function(v){ v.setAttribute('controls', ''); v.removeAttribute('loop'); });
        return;
      }
      function start(v){ if (v.preload === 'none') v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function(){}); }
      if (!('IntersectionObserver' in window)) { vids.forEach(start); return; }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if (en.isIntersecting) { en.target.setAttribute('data-rx-in', '1'); start(en.target); }
          else { en.target.setAttribute('data-rx-in', '0'); en.target.pause(); }
        });
      }, { threshold: 0.35 });
      vids.forEach(function(v){ io.observe(v); });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rx-quickbuy"] && !Shopify.designMode) return;
  try {
    (function(){
    function sync(ids){
      var box = document.querySelector('[data-rxq]');
      if (!box) return;
      var dyn = box.querySelector('[data-rxq-dyn]');
      var buy = box.querySelector('[data-rxq-buy]');
      var idin = box.querySelector('[data-rxq-id]');
      var single = ids.length === 1;
      buy.setAttribute('data-ids', ids.join(','));
      buy.hidden = single;
      dyn.hidden = !single;
      if (single && idin && idin.value !== ids[0]) {
        idin.value = ids[0];
        idin.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    document.addEventListener('change', function(e){
      var r = e.target;
      if (!r || !r.matches || !r.matches('.rxp__sets input[type="radio"]')) return;
      sync((r.getAttribute('data-ids') || '').split(',').filter(Boolean));
    });
    document.addEventListener('click', function(e){
      var b = e.target.closest && e.target.closest('[data-rxq-buy]');
      if (!b) return;
      e.preventDefault();
      var ids = (b.getAttribute('data-ids') || '').split(',').filter(Boolean);
      if (!ids.length) return;
      var label = b.textContent;
      b.disabled = true;
      b.textContent = 'One moment...';
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
        .then(function(){
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: ids.map(function(id){ return { id: Number(id), quantity: 1 }; }) })
          });
        })
        .then(function(r){ if (!r.ok) throw new Error('add failed'); window.location.href = '/checkout'; })
        .catch(function(){
          b.disabled = false;
          b.textContent = label;
          alert('Sorry, we could not start checkout. Please try again.');
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
